import { render, staticRenderFns } from "./ParentLogin.vue?vue&type=template&id=dc823094&scoped=true"
import script from "./ParentLogin.vue?vue&type=script&lang=js"
export * from "./ParentLogin.vue?vue&type=script&lang=js"
import style0 from "./ParentLogin.vue?vue&type=style&index=0&id=dc823094&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc823094",
  null
  
)

export default component.exports